import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import HomePage from '../pages/HomePage';
import ResultsPage from '../pages/ResultsPage';
import HistoryPage from '../pages/HistoryPage';
import LeaderboardPage from '../pages/LeaderboardPage';
import AchievementsPage from '../pages/AchievementsPage';
import ProfilePage from '../pages/ProfilePage';
import authService from '../services/AuthService';
import { getSwipeOrder } from '../hooks/useSwipeNavigation';

// Las páginas permanecen siempre montadas (display:none cuando no están activas)
// para que la navegación entre ellas sea instantánea y sin recargar datos del
// servidor. La posición de cada página es i*100% - offsetPx: un único sistema
// de coordenadas continuo que nunca cambia de referencia, así que la transición
// de un gesto puede seguir animándose sin saltos incluso después de navigate().
// Logros y Perfil solo se montan (y aparecen en el carrusel) con sesión iniciada.
const PAGE_COMPONENTS = {
  '/': HomePage,
  '/results': ResultsPage,
  '/history': HistoryPage,
  '/leaderboard': LeaderboardPage,
  '/achievements': AchievementsPage,
  '/profile': ProfilePage,
};
const ADJACENT_RANGE = 1;

export default function SwipeableMainViews({ offsetPx, isDragging }) {
  const location = useLocation();
  const swipeOrder = getSwipeOrder(authService.isAuthenticated());
  const activeIndex = swipeOrder.indexOf(location.pathname);
  const isActive = activeIndex !== -1;

  return (
    <Box
      sx={{
        display: isActive ? 'block' : 'none',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {swipeOrder.map((path, i) => {
        const PageComponent = PAGE_COMPONENTS[path];
        const isAdjacent = Math.abs(i - activeIndex) <= ADJACENT_RANGE;

        return (
          <Box
            key={path}
            sx={{
              display: isAdjacent ? 'flex' : 'none',
              flexDirection: 'column',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              transform: `translateX(calc(${i * 100}% - ${offsetPx}px))`,
              transition: isDragging ? 'none' : 'transform 0.25s ease',
            }}
          >
            <PageComponent />
          </Box>
        );
      })}
    </Box>
  );
}
